import React from 'react';
import { faEllipsisVertical } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { ActionIcon, Menu } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import { useTranslation } from 'react-i18next';
import { Delete, Edit, New, VersionFormModal } from './components';
import { VersionSelectContextMenuContext } from './context';

type VersionSelectContextMenuPropsType = React.PropsWithChildren & {
  handleSaveEdit: (data: { version: string }) => Promise<void>;
  handleSaveNew: (data: { version: string }) => Promise<void>;
  handleDelete: (version: string) => void;
  selectedVersion: string;
};

export const VersionSelectContextMenuRoot: React.FC<
  VersionSelectContextMenuPropsType
> = ({
  children,
  handleSaveEdit,
  handleSaveNew,
  handleDelete,
  selectedVersion,
}) => {
  const { t } = useTranslation();
  const [openedEdit, { open: openEdit, close: closeEdit }] =
    useDisclosure(false);
  const [openedNew, { open: openNew, close: closeNew }] = useDisclosure(false);

  return (
    <VersionSelectContextMenuContext.Provider
      value={{
        openEdit,
        openNew,
        handleDelete,
        selectedVersion,
      }}
    >
      <Menu position="right-start">
        <Menu.Target>
          <ActionIcon
            variant="subtle"
            role="button"
            aria-label={t('VERSION_SELECT.MENU.LABEL')}
          >
            <FontAwesomeIcon icon={faEllipsisVertical} />
          </ActionIcon>
        </Menu.Target>
        <Menu.Dropdown>{children}</Menu.Dropdown>
      </Menu>
      <VersionFormModal
        opened={openedEdit}
        onClose={closeEdit}
        onSave={handleSaveEdit}
        defaultVersionValue={selectedVersion}
      />
      <VersionFormModal
        opened={openedNew}
        onClose={closeNew}
        onSave={handleSaveNew}
      />
    </VersionSelectContextMenuContext.Provider>
  );
};

export const VersionSelectContextMenu = Object.assign(
  VersionSelectContextMenuRoot,
  {
    Delete,
    Edit,
    New,
  }
);
